import { request, solomonBaseUrl } from '@/libs/api-request'
import { BEUSABLY_URL, getS3Url } from '@/libs/utils'
import { IS_PRODUCTION } from '@/libs/constants'
import { readAnalytics, readCta, readFrequency, readDailyDevice, readUtm, readDailyScroll } from '@/libs/heatmap-v2/followup'

export function getReportPeriod (aid) {
  const config = {
    method: 'get',
    url: `/calendar/get_range/${aid}`
  }

  return request(config).then(data => {
    return data
  })
}

export function getReportPeriodByAbTest (aid) {
  const config = {
    method: 'get',
    url: `/calendar/get_range/by_abtest/${aid}`
  }

  return request(config).then(data => {
    return data
  })
}

export function getCaptureImageUrl (params, timestamp, isApi = true) {
  const config = {
    method: 'post',
    url: '/coords/get_image_path',
    data: params
  }

  // do not use cache
  return request(config, true).then(data => {
    if (data && data.imagePath) {
      return isApi ? getCaptureImage(data.imagePath, timestamp) : getS3Url(data.imagePath, timestamp)
    }
    return null
  }).catch(() => {
    return null
  })
}

export function getCaptureImage (pathKey, timestamp) {
  let baseUrl = 'http://localhost:5000'

  if (process.env.VUE_APP_API_BASE_URL) {
    baseUrl = process.env.VUE_APP_API_BASE_URL
  } else if (IS_PRODUCTION) {
    baseUrl = 'https://dream-api.beusable.net'
  }

  if (!pathKey) {
    return null
  }

  pathKey = encodeURIComponent(pathKey)

  let url = `${baseUrl}/coords/image?path=${pathKey}`
  if (timestamp) {
    url += `?v=${timestamp}`
  }
  return url
}

export function getAvgFoldData (params) {
  const config = {
    method: 'post',
    url: '/es/get_average_fold',
    data: params
  }

  return request(config).then(data => {
    const avgFold = data[params.device]

    if (avgFold) {
      return { avgFold }
    }
    return null
  })
}

export function getHeatmapData (params) {
  const config = {
    method: 'post',
    url: '/es/get_heatmap_by_event',
    data: params
  }

  return request(config).then(data => {
    return data
  }).catch(err => {
    if (err.message === 'No Coords found') {
      return null
    }
    throw err
  })
}

export function getCoordsData (params) {
  const config = {
    method: 'post',
    url: '/coords/get_coords_data_by_abtext',
    data: params
  }

  return request(config).then(data => {
    return data
  }).catch(err => {
    if (err.message === 'No Coords found') {
      return null
    }
    throw err
  })
}

export function getSwipeData (params) {
  const config = {
    method: 'post',
    url: '/es/get_swipe',
    data: params
  }

  return request(config).then(data => {
    return data
  }).catch(err => {
    if (err.message === 'No Coords found') {
      return null
    }
    throw err
  })
}

export function getScrollData (params) {
  const config = {
    method: 'post',
    url: '/es/get_scroll',
    data: params
  }

  return request(config)
}

export function getDailyScrollData (params, timezone, outcome) {
  const config = {
    method: 'post',
    url: '/es/get_daily_scroll',
    data: params
  }

  return readDailyScroll(params, timezone, () => request(config), outcome)
}

export function getBasicInfoData (params) {
  const config = {
    method: 'post',
    url: '/es/get_basic_info',
    data: params
  }

  return request(config)
}

export function getTestResult (params, cancelToken) {
  const config = {
    method: 'post',
    url: `${solomonBaseUrl()}/question/ask`,
    headers: {
      Authorization: `Bearer ${sessionStorage.getItem('reportchat_accessToken')}`
    },
    data: params
  }
  if (cancelToken) {
    config.cancelToken = cancelToken
  }
  return request(config)
}

export function getStreamPathData (params) {
  const config = {
    method: 'post',
    url: '/es/get_path',
    data: params
  }

  return request(config).then(data => {
    return data
  }).catch(err => {
    if (err.message.toLowerCase() === 'no stream found') {
      return null
    }
    throw err
  })
}

export function getAnalyticsData (params, timezone, outcome) {
  const config = {
    method: 'post',
    url: '/es/get_analytics',
    data: params
  }

  return readAnalytics(params, timezone, () => request(config), outcome)
}

export function getDailyDevice (params, timezone, outcome) {
  const config = {
    method: 'post',
    url: '/es/get_daily_device',
    data: params
  }

  return readDailyDevice(params, timezone, () => request(config), outcome)
}

export function getCtaData (params, timezone, outcome) {
  const config = {
    method: 'post',
    url: '/es/get_cta',
    data: params
  }

  return readCta(params, timezone, () => request(config), outcome)
}

export function getUtm (params, timezone, outcome) {
  const config = {
    method: 'post',
    url: '/es/get_utm',
    data: params
  }

  return readUtm(params, timezone, () => request(config), outcome)
}

export function getUtid (sid) {
  const config = {
    method: 'get',
    url: `/ut/get_all?sid=${sid}`
  }

  return request(config)
}

export function getHeatmapImage (params) {
  const config = {
    method: 'post',
    url: `${BEUSABLY_URL}/viewer/beusable_capture`,
    data: params
  }

  return request(config)
}

export function getHourBasicInfoData (params) {
  const config = {
    method: 'post',
    url: `/es/get_hour_basic_info`,
    data: params
  }

  return request(config)
}

export function getFreqInfoData (params, timezone, outcome) {
  const config = {
    method: 'post',
    url: `/es/get_freq_info`,
    data: params
  }

  return readFrequency(params, timezone, () => request(config), outcome)
}
